import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { RouteLink } from "Routes";

const RedirectGamesStoryPage = (props: { code: string }) => {
    const { code } = props;

    const history = useHistory();

    useEffect(() => {
        history.push(RouteLink.discoverHallOfFameStory(code));
    }, [code, history]);

    return null;
};

export default RedirectGamesStoryPage;
